import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5415df04")

_pushScopeId("data-v-5415df04")
const _hoisted_1 = {
  class: "color1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 6.9"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", { d: "M0 0L8 0 4 6.9z" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
})